import type { QueryFunctionContext } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { getPlpMenuQuery } from 'lib/queries/product/plpMenu';
import { client } from 'lib/sanity';
import type { PLPMenu } from 'types/cms/PLPMenu';
import type { SiteCategory } from 'types/common/SiteCategory';

import { useIsSkincare } from './useIsSkincare';

export type QueryKey = [string, SiteCategory];

export const PLP_MENU_KEY = 'plpMenu';

export const fetchPlpMenuProducts = async ({
  queryKey,
}: QueryFunctionContext<QueryKey>) => {
  const [, category] = queryKey;

  const plpMenu: PLPMenu = await client.fetch(getPlpMenuQuery(category));

  const productSlugs = plpMenu
    ? [
        ...new Set(
          plpMenu.plpMenu.flatMap(
            (item) =>
              item.primaryCollection?.products.map((product) => product.slug) ||
              [],
          ),
        ),
      ]
    : [];

  return productSlugs;
};

export const usePlpMenuProducts = () => {
  const isSkincare = useIsSkincare();

  return useQuery({
    queryKey: [PLP_MENU_KEY, isSkincare ? 'skincare' : 'supplements'],
    queryFn: fetchPlpMenuProducts,
  });
};
